/* ============================================================================
   ICA INSIGHTS BLOG — client-side tag filter (P11)
   No page reload. Toggles [hidden] on .ica-blog-card by their data-tag.

   FILTER CONTRACT (per Strategist brief §2, default-hide rule):
   - "all"      -> show every card EXCEPT company-tagged.
   - single tag -> show cards whose data-tag includes that tag, AND keep
                   company-tagged cards hidden (even if they also carry the tag).
   - "company"  -> show ONLY company-tagged cards.

   data-tag is a space-separated list of the post's primary + secondary tags.
   ========================================================================== */
(function () {
  'use strict';

  function initRoot(root) {
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var grid = root.querySelector('[data-ica-grid]');
    if (!chips.length || !grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.ica-blog-card'));
    var meta = root.querySelector('[data-ica-results-meta]');
    var empty = root.querySelector('[data-ica-empty]');

    function apply(filter) {
      var shown = 0;
      cards.forEach(function (card) {
        var tags = (card.getAttribute('data-tag') || '').split(/\s+/);
        var isCompany = tags.indexOf('company') > -1;
        var visible;
        if (filter === 'company') {
          visible = isCompany;
        } else if (filter === 'all') {
          visible = !isCompany;
        } else {
          visible = tags.indexOf(filter) > -1 && !isCompany;
        }
        card.hidden = !visible;
        if (visible) shown++;
      });

      if (meta) {
        meta.textContent =
          'Showing ' + shown + ' insight' + (shown === 1 ? '' : 's') +
          (filter === 'all' ? '' : ' · ' + filter);
      }
      if (empty) empty.hidden = shown !== 0;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        apply(chip.getAttribute('data-filter'));
      });
    });

    // Initial state: respect whichever chip is pre-pressed, else "all".
    var active = root.querySelector('[data-filter][aria-pressed="true"]');
    apply(active ? active.getAttribute('data-filter') : 'all');
  }

  function init() {
    var roots = document.querySelectorAll('[data-ica-blog-filter]');
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
